(function(){

	var loadScript = function(url, callback){
 
		var script = document.createElement("script");
		script.type = "text/javascript";
		
		// if the browser is Internet Explorer.
		if (script.readyState){ 
			script.onreadystatechange = function(){
			if (script.readyState == "loaded" || script.readyState == "complete"){
				script.onreadystatechange = null;
				callback();
			}
		};
		// for any other browser.
		} else {
			script.onload = function(){
				callback();
			};
		}
		
		script.src = url;
		document.getElementsByTagName("head")[0].appendChild(script);
		
	};
	
	var myAppJavaScript = function($){
		
		if ($('#outline_instagram').length) {
	
			if (OUTLINE_INSTAGRAM_NS.instagrams.length > 0) {
			
				var output = '';
              
                    output += '<div class="section instagram">';
                      output += '<div class="wrapper">';
              
              			output += '<div class="inner center-text hide_600">';
                        	output += '<p class="baton-turbo-font" style="margin-bottom: 0;">Instagram</p>';
                        output += '</div>';  
              
              			output += '<div class="flex space-between align-center">';
              
                        	output += '<div class="one-fourth show_600 center-text">';
              					output += '<div class="inner">';
                                  output += '<p class="baton-turbo-font" style="margin-bottom: 0;">Instagram</p>';              						
              					  output += '<p class="handle">' + OUTLINE_INSTAGRAM_NS.handle + '</p>';
              					output += '</div>';
                            output += '</div>';
              
                        	output += '<div class="one-fourth">';
              					output += '<div class="inner">';
              						output += '<a href="' + OUTLINE_INSTAGRAM_NS.instagrams[0].link + '" target="_blank"><img src="' + OUTLINE_INSTAGRAM_NS.instagrams[0].src + '" alt=""></a>';
              					output += '</div>';
                            output += '</div>';
              
                        	output += '<div class="one-fourth">';
              					output += '<div class="inner">';
              						output += '<a href="' + OUTLINE_INSTAGRAM_NS.instagrams[1].link + '" target="_blank"><img src="' + OUTLINE_INSTAGRAM_NS.instagrams[1].src + '" alt=""></a>';
              					output += '</div>';
                            output += '</div>';
              
                        	output += '<div class="one-fourth">';
              					output += '<div class="inner">';
              						output += '<a href="' + OUTLINE_INSTAGRAM_NS.instagrams[2].link + '" target="_blank"><img src="' + OUTLINE_INSTAGRAM_NS.instagrams[2].src + '" alt=""></a>';
              					output += '</div>';
                            output += '</div>';              
              
                        output += '</div>';                         
              
                      output += '</div>';              
                    output += '</div>'; 
                         
				
				$('#outline_instagram').append(output);
			
			}
		
		}
		
	};
	
	if ((typeof jQuery === 'undefined') || (parseFloat(jQuery.fn.jquery) < 1.7)) {
		loadScript('//ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js', function(){
			jQuery1124 = jQuery.noConflict(true);
			myAppJavaScript(jQuery1124);
		});
	} else {
		myAppJavaScript(jQuery);
	}

})();